import { render, staticRenderFns } from "./layout-sent.vue?vue&type=template&id=46f7b404&scoped=true"
import script from "./layout-sent.vue?vue&type=script&lang=js"
export * from "./layout-sent.vue?vue&type=script&lang=js"
import style0 from "./layout-sent.vue?vue&type=style&index=0&id=46f7b404&prod&lang=scss&scoped=true"
import style1 from "./layout-sent.vue?vue&type=style&index=1&id=46f7b404&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f7b404",
  null
  
)

export default component.exports